import { apiGet } from "../standardApi";

export const apiMedadomURL = async () => {
    return apiGet('/profile/MedadomUrl');
};